import cn from 'classnames';
import React from 'react';
import { Typography, TypographyProps } from '@react-md/typography';

interface Props extends TypographyProps {
    title: string;
}

export const AuthSectionHead: React.FC<Props> = ({ title, className = 'small-margin-bottom', ...props }) => {
    return (
        <Typography type="headline-3" component="div" {...props} className={cn('fieldset-grid-cell', className)}>
            {title}
        </Typography>
    );
};

export const AuthSectionText: React.FC<TypographyProps> = ({ children, ...props }) => {
    return (
        <Typography type="body-2" component="div" {...props}>
            {children}
        </Typography>
    );
};

export const AuthSection: React.FC<Props> = ({ title, className, children, ...props }) => {
    return (
        <div className={cn('fieldset-grid', 'base-paddings', className)} {...props}>
            <AuthSectionHead title={title} />
            {children}
        </div>
    );
};
